import React from 'react';
import { useDispatch } from 'react-redux';
import { Button, FormControl, IconButton, InputAdornment, InputLabel, OutlinedInput, Grid } from '@mui/material';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import { useChangePasswordMutation } from '../../features/api/rest/apiPasswordSlice';
import { setAlertMessage } from '../../features/layoutSlice';

function ChangePassword() {
  const [newPassword, setNewPassword] = React.useState({ new_password1: '', new_password2: '' });
  const [showPwd1, setShowPwd1] = React.useState(false);
  const [showPwd2, setShowPwd2] = React.useState(false);
  const [changePasswordMutationTrigger, { isSuccess, isError }] = useChangePasswordMutation();
  const { t } = useTranslation();
  const dispatch = useDispatch();

  React.useEffect(() => {
    if (isSuccess) {
      dispatch(setAlertMessage({ text: t('profile.editForm.fields.changePassword.messages.success'), type: 'success' }));
      setNewPassword({ new_password1: '', new_password2: '' });
    }
    if (isError) {
      dispatch(setAlertMessage({ text: t('profile.editForm.fields.changePassword.messages.error'), type: 'error' }));
    }
  }, [isSuccess, isError, dispatch, t]);

  const handleNewPasswordSubmit = async (event) => {
    event.preventDefault();
    changePasswordMutationTrigger({ new_password1: newPassword.new_password1, new_password2: newPassword.new_password2 });
  };

  return (
    <Grid container spacing={2} data-testid="ChangePassword">
      <Grid item xs={12} sm={6}>
        <FormControl sx={{ width: '100%' }} variant="outlined">
          <InputLabel htmlFor="newPassword1-input">{t('profile.editForm.fields.changePassword.newPassword1.label')}</InputLabel>
          <OutlinedInput
            id="newPassword1-input"
            type={showPwd1 ? 'text' : 'password'}
            required
            value={newPassword.new_password1}
            onChange={(e) => setNewPassword({ ...newPassword, new_password1: e.target.value })}
            endAdornment={
              <InputAdornment position="end">
                <IconButton aria-label={t('aria.icons.togglePasswordVisibility')} onClick={() => setShowPwd1(!showPwd1)} onMouseDown={(e) => e.preventDefault()} edge="end" data-testid="TogglePasswordVisibilityButton1">
                  {showPwd1 ? <VisibilityOff /> : <Visibility />}
                </IconButton>
              </InputAdornment>
            }
            label={t('profile.editForm.fields.changePassword.newPassword1.label')}
          />
        </FormControl>
      </Grid>
      <Grid item xs={12} sm={6}>
        <FormControl sx={{ width: '100%' }} variant="outlined">
          <InputLabel htmlFor="newPassword2-input">{t('profile.editForm.fields.changePassword.newPassword2.label')}</InputLabel>
          <OutlinedInput
            id="newPassword2-input"
            type={showPwd2 ? 'text' : 'password'}
            required
            value={newPassword.new_password2}
            onChange={(e) => setNewPassword({ ...newPassword, new_password2: e.target.value })}
            endAdornment={
              <InputAdornment position="end">
                <IconButton aria-label={t('aria.icons.togglePasswordVisibility')} onClick={() => setShowPwd2(!showPwd2)} onMouseDown={(e) => e.preventDefault()} edge="end" data-testid="TogglePasswordVisibilityButton2">
                  {showPwd2 ? <VisibilityOff /> : <Visibility />}
                </IconButton>
              </InputAdornment>
            }
            label={t('profile.editForm.fields.changePassword.newPassword2.label')}
          />
        </FormControl>
      </Grid>
      <Grid item xs={12}>
        <Button type="submit" variant="contained" color="primary" onClick={handleNewPasswordSubmit} disabled={!newPassword.new_password1 || !newPassword.new_password2}>
          {t('profile.editForm.fields.changePassword.submit')}
        </Button>
      </Grid>
    </Grid>
  );
}

export default ChangePassword;
